import { Link } from 'gatsby'
import React from 'react'
import { Grid } from 'semantic-ui-react'

import * as styles from "./styles/header.module.css";

const UtilityBar = () => {
    return (
        <div className={styles.utilityBar}>
            <Grid>
                <Grid.Column width={15} textAlign='right'>
                    <p>
                        <span>Be a Partner:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>
                            <Link to="/seller">Start Selling</Link>
                        </span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>
                            <Link to="/franchisor">List your Franchise</Link>
                        </span>
                    </p>
                </Grid.Column>
            </Grid>
        </div>
    )
}

export default UtilityBar